import { IonCol, IonGrid, IonIcon, IonRow, IonSpinner } from '@ionic/react';
import React, { useMemo } from 'react';

import {
  addCircleSharp,
  cameraSharp,
  checkmarkCircleSharp,
  eyeSharp,
} from 'ionicons/icons';

import './FileUploader.scss';
import { FileUploaderProps } from './types';


const FileUploader: React.FC<FileUploaderProps> = ({
  fileData: {
    label,
    isLoading,
    uploaded,
    disabled,
    counter,
    canViewFile,
    showUploadedState,
    showUploadAction,
  },
  onShowCameraOptions,
  onFileChange,
  onViewFile,
  inputRefSetter,
}) => {
  const classes = useMemo(
    () => ({
      wrapper: `file-uploader${disabled ? ' disabled' : ''}`,
      messageContainer: 'file-uploader__msg',
    }),
    [disabled],
  );

  const total = counter ?? (uploaded ? 1 : 0);
  const hasFiles = total > 0;
  const canView = canViewFile ?? hasFiles;
  const shouldShowUploadedState = (showUploadedState ?? true) && hasFiles;
  const shouldShowUploadAction = showUploadAction ?? true;

  const getUploadStatus = (): { icon: JSX.Element; message: string } => {
    if (isLoading) {
      return {
        icon: <IonSpinner name="circular" color="primary" />,
        message: `Subiendo ${label}...`,
      };
    }

    if (shouldShowUploadedState) {
      return {
        icon: <IonIcon icon={checkmarkCircleSharp} />,
        message: `${label} cargado`,
      };
    }

    return {
      icon: <IonIcon icon={addCircleSharp} />,
      message: `Cargar ${label}`,
    };
  };

  const { icon, message } = getUploadStatus();

  const handleViewFile = () => {
    if (canView && onViewFile) {
      onViewFile();
    }
  };

  return (
    <div className={classes.wrapper}>
      <IonGrid className="ion-no-padding">
        <IonRow>
          <IonCol
            size="1.5"
            className={`file-uploader__start-icon file-uploader__start-icon--${shouldShowUploadedState ? 'loaded' : 'pending'}`}
          >
            {icon}
          </IonCol>

          <IonCol size="7.5">
            <div className={classes.messageContainer}>
              <div>{message}</div>
            </div>
          </IonCol>

          <IonCol className="file-uploader__icons-end-col">
            {shouldShowUploadAction && (
              <IonIcon
                icon={cameraSharp}
                color="primary"
                onClick={() => !disabled && !isLoading && onShowCameraOptions()}
              />
            )}
            <IonIcon
              icon={eyeSharp}
              onClick={handleViewFile}
              color={canView && !isLoading && (showUploadedState ?? true) ? 'dark' : 'medium'}
            />
          </IonCol>
        </IonRow>
      </IonGrid>

      <input
        style={{ display: 'none' }}
        type="file"
        accept="application/pdf"
        ref={inputRefSetter}
        onChange={onFileChange}
      />
    </div>
  );
};

export default React.memo(FileUploader);
